import { useRouteMatch } from "react-router-dom";
import { ShowPageLink } from "@/react/components/PostsV3/PostViewListItem/ShowPageLink";
import {
  LOCATION_TYPES,
  STATUS,
} from "@circle-react/components/Events/helpers/constants";
import { PostCoverImage as PostCoverImageV3 } from "@circle-react/components/PostsV3/PostViewListItem/PostCoverImage";
import { dateIsPast } from "@circle-react/helpers/dateTimeHelpers";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { InPersonLocation } from "../NewEventsSpace/EventDetailPage/InPersonLocation";
import { RsvpActionButton } from "../NewEventsSpace/EventDetailPage/RsvpActionButton";
import { ListViewEventTimestamp } from "../NewEventsSpace/ListViewItem/ListViewEventTimestamp";
import { EventInfoChips, RsvpWarningMessages } from "../NewEventsSpace/shared";
import { canRespondToInvitation } from "../NewEventsSpace/shared/helpers";

interface Props {
  event: any;
  onChange: () => void;
}
export const NewEventsEmbed = ({ event, onChange }: Props) => {
  const { name, event_setting_attributes: eventData, status } = event;

  const isHomePage = useRouteMatch("/home")?.isExact;
  const isFeedPage = useRouteMatch("/feed")?.isExact;

  const {
    starts_at: startsAt,
    ends_at: endsAt,
    time_zone: timeZone,
    hide_location_from_non_attendees: hideLocationFromNonAttendees,
    in_person_location: inPersonLocation,
    location_type: locationType,
  } = eventData || {};

  const isEventFinished = !!startsAt && dateIsPast(startsAt);
  const isInPersonEventType = locationType === LOCATION_TYPES.IN_PERSON;
  const isPublished = status === STATUS.PUBLISHED;
  const shouldDisplayRsvpAction =
    !isEventFinished && isPublished && canRespondToInvitation(event);

  return (
    <div
      className={classNames("border-primary m-4 rounded-lg border p-6", {
        "mx-5 !mb-5 !mt-0 md:!mx-6": isHomePage || isFeedPage,
      })}
    >
      {event.cover_image_url && (
        <div className="event-item--post-view__new-event-cover-image mb-4">
          <PostCoverImageV3
            post={event}
            startsAt={startsAt}
            endsAt={endsAt}
            timeZone={timeZone}
            wrapperClassName="!p-0"
          />
        </div>
      )}

      <div className="flex flex-row items-start justify-between">
        <div className="space-y-2">
          <ShowPageLink
            shouldOpenPostModal={isFeedPage}
            post={event}
            className="text-dark block text-2xl font-bold"
          >
            {name}
          </ShowPageLink>
          <ListViewEventTimestamp
            event={event}
            displayAddToCalenderInline={false}
            isRenderedOutsideListItem
          />
        </div>
        <div className="hidden sm:block">
          {shouldDisplayRsvpAction && (
            <RsvpActionButton event={event} onChange={onChange} />
          )}
        </div>
      </div>
      <RsvpWarningMessages event={event} />

      {!hideLocationFromNonAttendees &&
        isInPersonEventType &&
        inPersonLocation && (
          <InPersonLocation serializedLocation={inPersonLocation} />
        )}
      <EventInfoChips event={event} shouldHideLocation={isInPersonEventType} />
      {shouldDisplayRsvpAction && (
        <div className="mt-4 block sm:hidden">
          <RsvpActionButton event={event} onChange={onChange} />
        </div>
      )}
    </div>
  );
};
